import XHR from '@/request/http'
const $h = new XHR()

// url
const url = {
    // 课程相关
    lists: '/admin/v1/course/page',
    save: '/admin/v1/course/save',
    del: '/admin/v1/course/delete',
    get_course: '/admin/v1/course/get',
    all: '/admin/v1/course/list',

    // 章节相关（基础路径 /admin/v1/chapter）
    chapter_list: '/admin/v1/chapter/list',
    chapter_tree: '/admin/v1/chapter/tree',
    chapter_save: '/admin/v1/chapter/save',
    chapter_del: '/admin/v1/chapter/delete',
    chapter_get: '/admin/v1/chapter/detail',
}

// ==================== 课程 API ====================

// 课程分页列表
export async function lists(data) {
    return $h.request(url.lists, data, 'GET')
}

// 课程全部列表（不分页）
export async function all(data) {
    return $h.request(url.all, data, 'GET')
}

// 保存课程（新增/修改，id为空则新增，id不为空则修改）
export async function save(data) {
    return $h.request(url.save, data, 'POST')
}

// 删除课程（路径参数）
export async function del(id) {
    return $h.request(url.del + '/' + id, {}, 'POST')
}

// 获取课程详情（Query参数）
export async function get_course(data) {
    return $h.request(url.get_course, data, 'GET')
}

// ==================== 章节 API ====================

// 章节平铺列表
export async function chapter_list(data) {
    return $h.request(url.chapter_list, data, 'GET')
}

// 章节树形结构
export async function chapter_tree(data) {
    return $h.request(url.chapter_tree, data, 'GET')
}

// 保存章节（新增/修改，id为空则新增，id不为空则修改）
export async function chapter_save(data) {
    return $h.request(url.chapter_save, data, 'POST')
}

// 删除章节（路径参数）
export async function chapter_del(id) {
    return $h.request(url.chapter_del + '/' + id, {}, 'POST')
}

// 获取章节详情（路径参数）
export async function chapter_get(id) {
    return $h.request(url.chapter_get + '/' + id, {}, 'GET')
}
